import '../src/lib/publicPath';
import '../src/assets/iovation/iovation_loader'

document.addEventListener('iovationReady', (e) => {
  try {
    const iovationFormId = document.getElementById('io_black_box');
    iovationFormId.value = e.detail;
  } catch (error) {
    console.error(error);
  }
});
